<template>
  <div class="d-flex flex-column w-100">
    <el-card shadow="never">
      <div class="d-flex flex-row">
        <div class="cust-logo-display" @click="openChangeLogo">
          <el-image
            v-if="custInfo.bigImageCode"
            :src="custInfo.bigImageUrl"
            style="width: 100%;height: 100%;"
            fit="contain"
          />
          <span v-else>LOGO</span>
        </div>

        <div class="ml-2 d-flex flex-column flex-grow-1">
          <div class="flex-grow-1">
            <h5 class="mb-3">{{ custInfo.custShortName }}</h5>
            <h6>{{ custInfo.custName }}</h6>
          </div>

          <div
            style="font-size: 14px;color: #606266;min-width: max-content;"
            class="d-flex align-items-center"
          >
            <span> No：{{ custInfo.custNo }} </span>
            <el-divider direction="vertical" />
            <el-tag
              size="mini"
              :type="
                custInfo.custStatus === 'Y' || custInfo.custStatus === 'P'
                  ? 'success'
                  : custInfo.custStatus === 'W'
                  ? ''
                  : 'danger'
              "
            >
              {{ custInfo.v_custStatus || 'New' }}
            </el-tag>
            <el-divider direction="vertical" />
            <span class="mr-1">Update:</span>
            <span>
              {{ custInfo.modifyByName || '--' }} at
              {{ custInfo.modifyDate || '--' }}
            </span>
          </div>
        </div>
      </div>
    </el-card>

    <div class="customer-card">
      <div class="switch-tabs_wrappers">
        <div class="switch-tabs">
          <div
            v-for="item in switchTabs"
            :key="item.value"
            class="switch-tabs_items"
            :class="{ active: item.value === activeTab }"
            @click="activeTab = item.value"
          >
            <span>{{ item.label }}</span>
          </div>
        </div>
      </div>
      <div class="customer-card-body">
        <div>
          <el-card shadow="never">
            <keep-alive>
              <component
                :is="activeTab"
                :ref="activeTab"
                :custCode="custCode"
                :disabled="disabled || requestMap[activeTab]"
                :docDisabled="disabled"
                @loaded="(e) => (custInfo = e)"
              />
            </keep-alive>
          </el-card>
        </div>
      </div>
    </div>

    <CustLogo
      :visible.sync="custLogoVisible"
      :disabled="disabled"
      :bigImageCode="custInfo.bigImageCode"
      :bigImageUrl="custInfo.bigImageUrl"
      :middleImageCode="custInfo.middleImageCode"
      :middleImageUrl="custInfo.middleImageUrl"
      :smallImageCode="custInfo.smallImageCode"
      :smallImageUrl="custInfo.smallImageUrl"
      @change="custLogoChange"
    />
  </div>
</template>

<script>
import CustBase from './components/cust-base'
import CustContact from './components/cust-contact'
import CustCategoryBrandDep from './components/cust-category-brand-dep'
import CustFinance from './components/cust-finance'
import CustFactory from './components/cust-factory'
import CustSales from './components/cust-sales'
import CustFolder from './components/cust-folder'
import CustLogo from './components/cust-logo'
import EditLoading from '@/mixins/edit-loading'
export default {
  name: 'customerManage-info-v2-detail',
  components: {
    CustBase,
    CustContact,
    CustCategoryBrandDep,
    CustFinance,
    CustFactory,
    CustSales,
    CustFolder,
    CustLogo,
  },
  mixins: [EditLoading],
  data() {
    return { activeTab: 'cust-base', custInfo: {}, custLogoVisible: false }
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    disabled() {
      return this.pageType === 'detailV2'
    },
    isRequest() {
      return !['A'].includes(this.custInfo.custMode) || this.custInfo.request
    },
    requestMap() {
      return {
        'cust-base': this.isRequest,
        'cust-finance': this.isRequest,
        'cust-factory': this.isRequest,
      }
    },
    custCode() {
      return this.params.custCode
    },
    switchTabs() {
      return [
        {
          label: this.$l('switchTabs_label_base') || '客户基本信息',
          value: 'cust-base',
        },
        {
          label: this.$l('switchTabs_label_contact') || '客户方联系人',
          value: 'cust-contact',
        },
        {
          label:
            this.$l('switchTabs_label_categoryBrandDep') || '客户品类及部门',
          value: 'cust-category-brand-dep',
        },
        {
          label: this.$l('switchTabs_label_finance') || '财务信息',
          value: 'cust-finance',
        },
        {
          label: this.$l('switchTabs_label_factory') || '验厂相关',
          value: 'cust-factory',
        },
        {
          label: this.$l('switchTabs_label_sales') || '业务人员配置',
          value: 'cust-sales',
        },
        {
          label: this.$l('switchTabs_label_folder') || '客人文档',
          value: 'cust-folder',
        },
      ]
    },
  },
  methods: {
    openChangeLogo() {
      if (this.disabled) return
      this.custLogoVisible = true
    },
    async custLogoChange({
      bigImageCode,
      bigImageUrl,
      middleImageCode,
      middleImageUrl,
      smallImageCode,
      smallImageUrl,
    }) {
      const params = {
        custCode: this.custCode,
        bigImageCode,
        bigImageUrl,
        middleImageCode,
        middleImageUrl,
        smallImageCode,
        smallImageUrl,
      }

      if (this.loadingOpen()) return
      const res = await this.$api
        .masterCustomerChangeLogoApi(params)
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }

      this.custInfo.bigImageCode = bigImageCode
      this.custInfo.bigImageUrl = bigImageUrl
      this.custInfo.middleImageCode = middleImageCode
      this.custInfo.middleImageUrl = middleImageUrl
      this.custInfo.smallImageCode = smallImageCode
      this.custInfo.smallImageUrl = smallImageUrl
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-card {
    border: none;
  }
  .el-card__body {
    padding: 16px;
  }
  .el-input.is-disabled .el-input__inner,
  .el-textarea.is-disabled .el-textarea__inner {
    color: #606266 !important;
    background-color: #fff !important;
    border: 1px solid #dcdfe6 !important;
  }
}
.cust-logo-display {
  width: 92px;
  height: 92px;
  min-width: 92px;
  background-color: #f4f6f9;
  font-size: 14px;
  color: #101010;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

::v-deep {
  .customer-card {
    flex-grow: 1;
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    border-radius: 4px;
    overflow: hidden;
    min-height: 400px;
    .switch-tabs_wrappers {
      padding: 16px;
      background-color: #fff;
    }
    .customer-card-body {
      flex-grow: 1;
      position: relative;
      > div {
        position: absolute;
        height: 100%;
        width: 100%;
        overflow-y: auto;
        > .el-card {
          padding-top: 10px;
          border-top-left-radius: 0;
          border-top-right-radius: 0;
          .el-card__body {
            padding-top: 0;
          }
        }
      }
    }
  }
}
.switch-tabs_wrappers {
  .switch-tabs {
    display: flex;
    .switch-tabs_items {
      padding-top: 4px;
      padding-bottom: 10px;
      padding-left: 2px;
      padding-right: 2px;
      color: #6c757d;
      font-size: 14px;
      margin-right: 26px;
      cursor: pointer;
      min-width: max-content;
      border-bottom: 3px solid transparent;
    }
    .switch-tabs_items:hover,
    .switch-tabs_items.active {
      color: #007bff;
      border-color: #1989fa;
    }
    .switch-tabs_items.disabled {
      cursor: no-drop;
    }
    .switch-tabs_items.disabled:hover {
      color: #8cc5ff;
      border-color: #7ab8f6;
    }
    .switch-tabs_items:last-child {
      margin-right: 0;
    }
  }
}
</style>
